import { render, staticRenderFns } from "./RelatorioCliente.vue?vue&type=template&id=19736b7f"
import script from "./RelatorioCliente.vue?vue&type=script&lang=js"
export * from "./RelatorioCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports